export const RESET_PASSWORD_REDUCER_NAME = 'resetPassword'
export const RESET_PASSWORD_INIT_REDUCER_NAME = 'init'
export const RESET_PASSWORD_CONFRIRM_REDUCER_NAME = 'confirm'
export const RESET_PASSWORD_TOKEN_VALIDATOR_REDUCER_NAME = 'tokenValidator'
